import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'


class InfoConnection extends Component {
  render() {
    const { community, intl, hideModal } = this.props
    let imgSrc = `${process.env.APP_BASE_URL}dist/images/aspire_networking${
      community === 'devry' ? '_devry' : ''
    }.jpg`
    return (
      <div className="info-connect-body">
        <button
          className="text-btn"
          tabIndex={0}
          aria-label={intl.formatMessage({
            id: 'infoConnection.infoConnection.closeModalAriaLabel',
            defaultMessage: 'Click to close the modal'
          })}
          onClick={hideModal}>
          <span className="icon-cross" />
        </button>
        <img
          src={imgSrc}
          alt="info modal"
        />
      </div>
    )
  }
}

export default injectIntl(InfoConnection)
